import { StripeElementClasses, StripeElementStyle } from '@stripe/stripe-js';
import cx from 'classnames';

export const inputStyle: StripeElementStyle = {
  base: {
    fontSize: '14px',
    fontFamily: '"Inter", Helvetica, sans-serif',
    ':disabled': {
      color: '#6A6C6E', // gray-600
    },
    '::placeholder': {
      color: '#6A6C6E', // gray-600
    },
  },
  invalid: {
    color: '#C8252A', // red-900
  },
};

const classes = (disabled: boolean, error: boolean): StripeElementClasses => ({
  base: cx(
    'relative border text-lg ring-inset font-sans text-md py-[15px] sm:py-[19px] px-16 text-sm leading-none outline-none',
    {
      'hover:bg-gray-50 border-black/16': !disabled,
      'bg-white text-gray-900 placeholder:text-gray-600': !disabled && !error,
      'bg-gray-100 text-gray-600 border-gray-100': disabled && !error,
    },
  ),
  focus: 'ring-1 border-primary-500 ring-primary-500 z-20',
  empty: 'text-gray-600',
});

export const cardClasses = (disabled: boolean, error: boolean): StripeElementClasses => {
  const baseClasses = classes(disabled, error);

  return {
    ...baseClasses,
    base: `${baseClasses.base} rounded-t-sm border-b-transparent`,
    focus: `${baseClasses.focus} border-b-primary-500`,
  };
};

export const expiryClasses = (disabled: boolean, error: boolean): StripeElementClasses => {
  const baseClasses = classes(disabled, error);

  return {
    ...baseClasses,
    base: `${baseClasses.base} rounded-bl-sm w-1/2 `,
  };
};

export const cvcClasses = (disabled: boolean, error: boolean): StripeElementClasses => {
  const baseClasses = classes(disabled, error);

  return {
    ...baseClasses,
    base: `${baseClasses.base} rounded-br-sm w-1/2 border-l-transparent`,
    focus: `${baseClasses.focus} border-l-primary-500`,
  };
};
